import { render, staticRenderFns } from "./OverviewDetail.vue?vue&type=template&id=6108ae0e&scoped=true"
import script from "./OverviewDetail.vue?vue&type=script&lang=js"
export * from "./OverviewDetail.vue?vue&type=script&lang=js"
import style0 from "./OverviewDetail.vue?vue&type=style&index=0&id=6108ae0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6108ae0e",
  null
  
)

export default component.exports